export const VISIT_CONFIGURATIONS_TABLE_UNIQUE_ID = 'visit-configurations';

// Keep in sync with _visit-configurations-table-columns.scss
// 'col-id' is not a free choice: TableColumnManager pins that exact class to the left edge
// (here holding the row-selection checkbox, not an id).
export const DEFAULT_VISIT_CONFIGURATIONS_COLUMN_WIDTHS: { [key: string]: number } = {
  'col-id': 40,
  'col-account': 200,
  'col-projection': 200,
  'col-skills': 180,
  'col-destination': 280,
  'col-frequency': 160,
  'col-time-window': 150,
  'col-start': 130,
  'col-expiration': 130,
  'col-created-on': 130,
  'col-updated-on': 130,
  'col-actions': 90
};
